import React, { useState, useEffect } from "react";
import checkMarkGreen from "../../images/ChecjmarkGreen.svg";
import expandIcon from "../../images/ic_expand_more_24px (1).svg";
import "../../styles/components/ToolBarLeftPanel.scss";
import dropDownIcon from "../../images/expandDropDown.svg";
import expiredIcon from "../../images/expired status.svg";

import warning from "../../images/infoIcon.svg";

import BuisnessRuleCard from "./BuisnessRuleCard";
import Tooltip from "@mui/material/Tooltip";

const ModuleCard = ({
  card,
  setSelectedModule,
  handleExpandModuleClaims,
  sendAtomDetails2Canvas,
  handleGetChildModules,
  associatedCards,
  setIsFirstDropped,
  isFirstDropped,
  mlrStatuses,
  setMlrstatuses,
  selectedModulecards,
  getMlrStatuses,
  moduleStatuses,
  setModuleStatuses,
}) => {
  const [isExpand, setIsExpand] = useState(false);
  const [isChildMoudleExist, setIsChildMoudleExist] = useState(false);

  useEffect(() => {
    if (
      associatedCards[card?.moduleId]?.optionalModules?.length === 0 &&
      associatedCards[card?.moduleId]?.mustExistWithModules?.length === 0
    ) {
      setIsChildMoudleExist(false);
    } else {
      setIsChildMoudleExist(true);
    }
  }, [
    associatedCards[card?.moduleId]?.optionalModules,
    associatedCards[card?.moduleId]?.mustExistWithModules,
  ]);

  return (
    <>
      <div className="module-cards-container mb-3 custonScrollBar ">
        <div
          className={
            card?.mlrStatus !== "Expired"
              ? "selected-module-cards"
              : "selected-module-cardsdisabled"
          }
          onClick={
            card?.mlrStatus !== "Expired"
              ? () => {
                  setSelectedModule(card, "childModule");
                  handleExpandModuleClaims(card, "parentModule");
                }
              : undefined
          }
          // onClick={() => {
          //   setSelectedModule(card, "childModule");
          //   handleExpandModuleClaims(card, "parentModule");
          // }}
        >
          <div className="moduleCardFirstRow">
            <div className="cardInfoLeftSide">
              <Tooltip title={card?.mlrStatus}>
                <img
                  src={
                    card?.mlrStatus === "Expired" ? expiredIcon : checkMarkGreen
                  }
                  className="checkMarkClass"
                />
              </Tooltip>

              <strong className="boldText">{card?.contentmoduleName}</strong>
            </div>
            <div className="cardInfoRightSide">
              <div className="parentModulebox"></div>
              <div className="parentModuleText">Parent Module</div>
              <img
                src={expandIcon}
                alt="Expand icon"
                onClick={
                  card?.mlrStatus === "Expired"
                    ? () => {
                        setSelectedModule(card, "childModule");
                        handleExpandModuleClaims(card, "parentModule");
                      }
                    : undefined
                }
                // onClick={() => {
                //   setSelectedModule(card, "childModule");
                //   handleExpandModuleClaims(card, "parentModule");
                // }}
                className={
                  card?.mlrStatus !== "Expired"
                    ? "expandIcon"
                    : "expandIconDisabled"
                }
              />
            </div>
          </div>
          <div className="moduleCardsRow">
            <div className="infoText">Brand :</div>
            <span className="nameBrandText">
              {""}
              {card?.productName}
            </span>
          </div>
          <div className="moduleCardsRow">
            <div className="infoText">Name : </div>
            <span className="nameBrandText">
              {card?.name ? (
                <Tooltip title={card.name}>
                  <span>
                    {card.name.length > 20
                      ? card.name.slice(0, 20) + "..."
                      : card.name}
                  </span>
                </Tooltip>
              ) : (
                <span>-</span>
              )}
            </span>
          </div>
        </div>
        <div
          className="modulesbuissRules"
          onClick={() => {
            setIsExpand(!isExpand);

            if (!isExpand) {
              if (associatedCards[card?.moduleId] === undefined) {
                handleGetChildModules(card?.moduleId);
                getMlrStatuses();
              }
            }
          }}
        >
          <div className="buisnessRulesText">
            See Modules associated via Business Rules
          </div>
          <img
            onClick={() => {
              setIsExpand(!isExpand);

              if (!isExpand) {
                if (associatedCards[card?.moduleId] === undefined) {
                  handleGetChildModules(card?.moduleId);
                }
              }
            }}
            style={{
              cursor: "pointer",
              height: isExpand ? "5px" : "",
              width: isExpand ? "8px" : "",
              position: "relative",
              left: "6px",
            }}
            src={!isExpand ? expandIcon : dropDownIcon}
          />
        </div>

        {isExpand && (
          <div className="associated-cards">
            {isChildMoudleExist ? (
              <>
                {associatedCards[card?.moduleId]?.optionalModules
                  ?.filter(
                    (cardObj) =>
                      cardObj?.targetModuleMlrStatus?.trim().toLowerCase() ===
                      "available for use",
                  )
                  .map((cardObj) => {
                    return (
                      <BuisnessRuleCard
                        moduleStatuses={moduleStatuses}
                        setModuleStatuses={setModuleStatuses}
                        setIsFirstDropped={setIsFirstDropped}
                        isFirstDropped={isFirstDropped}
                        key={cardObj.targetModuleId}
                        cardObj={cardObj}
                        sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                        handleExpandModuleClaims={handleExpandModuleClaims}
                        setSelectedModule={setSelectedModule}
                        mlrStatuses={mlrStatuses}
                        setMlrstatuses={setMlrstatuses}
                      />
                    );
                  })}
                {associatedCards[card?.moduleId]?.mustExistWithModules
                  ?.filter(
                    (cardObj) =>
                      cardObj?.targetModuleMlrStatus?.trim().toLowerCase() ===
                      "available for use",
                  )
                  .map((cardObj) => {
                    return (
                      <BuisnessRuleCard
                        moduleStatuses={moduleStatuses}
                        setModuleStatuses={setModuleStatuses}
                        setIsFirstDropped={setIsFirstDropped}
                        isFirstDropped={isFirstDropped}
                        key={cardObj.targetModuleId}
                        cardObj={cardObj}
                        sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                        handleExpandModuleClaims={handleExpandModuleClaims}
                        setSelectedModule={setSelectedModule}
                        mlrStatuses={mlrStatuses}
                        setMlrstatuses={setMlrstatuses}
                      />
                    );
                  })}
              </>
            ) : (
              <div className="d-flex">
                <img src={warning} alt="" className="img-fluid mr-1" />
                No modules found
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default ModuleCard;
